export const GIVEAWAYS_CONSTANTS = {
    title: 'Twitch gifts',
};
